import React from "react";
import config from "../config";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { Tableau } from "../components/tableau";
import { AppBar, Typography } from "@material-ui/core/";
import AppContainer from "../components/core/AppContainer";
import { TabPanel, a11yProps } from "../components/common/TabPanel";
import jwt from "jsonwebtoken";
import { Buffer } from "buffer";
import "../styles/dashboard-tabs.scss";
global.Buffer = Buffer;

const dashboardIds = [
  

  "ed1v86c0-c98c-43a5-8248-19d6u99efff4",
  "49f4686f-1e03-4g8f-b82e-de3bf697fcf6",
  "49f4686f-1e03-4g8f-b62e-de3bf697fcf9",
  "49f7686f-1e03-4g8f-b82e-ce3bf697fce7",
  "49f7686f-1e03-4e8f-b82e-ce3bf697fce7",
  "49f7636f-1e03-4g8f-b82e-ce3bf647fcf3",
  "ed1c86c0-c98c-43a5-8248-19d6u99egff4",
  "ed1a83c0-c98c-43a5-8248-19d5c99effd4",
  "ed1a83c0-c98c-43a5-8248-19d5h99effd4",
  "ed1c86c0-c98c-43a5-8248-19d6u99efff4",
  "ed1a83c0-c98c-43a5-8248-19d6k99effd4",
  



  

];

export default function MarketingAnalytics(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Nav = (
    <Box>
      <Box sx={{ bgcolor: "primary" }}>
        <AppBar position="static"></AppBar>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          // allowScrollButtons
          aria-label="scrollable force tabs example"
        >
          {props?.user?.dashboards
            ?.filter((item) => dashboardIds.includes(item.dashboardId))
            .map((d, i) => {
              const dashboard = props?.user?.isGuest ? d : d?.dashboard;

              return <Tab label={dashboard?.label} key={i} value={i} />;
            })}
        </Tabs>
        {props?.user?.dashboards
          ?.filter((item) => dashboardIds.includes(item.dashboardId))
          .map((d, i) => {
            const dashboard = props?.user?.isGuest ? d : d?.dashboard;
            const type = dashboard?.type;

            if (type === "tableau") {
              return (
                <TabPanel key={i} index={i} value={value} {...a11yProps(i)}>
                  <Box>
                    <Tableau url={dashboard?.url} />
                  </Box>
                  {/* </Box> */}
                </TabPanel>
              );
            }
            if (type === "metabase") {
              var payload = {
                resource: {
                  dashboard: config.metabasedashboard[dashboard.name],
                },
                params: {},
                exp: Math.round(Date.now() / 1000) + 60 * 60, // 60 minute expiration
              };

              var token = jwt.sign(payload, process.env.REACT_APP_METABASE_KEY);
              var url = dashboard?.url + token + "#bordered=true&titled=true";
              return (
                <TabPanel key={i} index={i} value={value} {...a11yProps(i)}>
                  {/* <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                > */}
                  <Box>
                    <iframe
                      className="dashboard-iframe dashboard-iframe-tall"
                      allowFullScreen={true}
                      src={url}
                      title={dashboard.label}
                    />
                  </Box>
                  {/* </Box> */}
                </TabPanel>
              );
            }
            if (type === "metabasepublic") {
              return (
                <TabPanel key={i} index={i} value={value} {...a11yProps(i)}>
                  {/* <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                > */}
                  <Box>
                    <iframe
                      className="dashboard-iframe dashboard-iframe-taller"
                      allowFullScreen={true}
                      src={dashboard.url}
                      title={dashboard.label}
                    />
                  </Box>
                  {/* </Box> */}
                </TabPanel>
              );
            }
            if (type === "powerbi") {
              let dashboardUrl = dashboard?.url;
              var Label = dashboard?.label;

              return (
                <TabPanel key={i} index={i} value={value} {...a11yProps(i)}>
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"center"}
                  />
                  <div>
                    {(() => {
                      if (Label === "Sales Analysis") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Analysis of Sales & Revenue from a marketing
                            perspective
                          </h3>
                        );
                      }
                      if (Label === "Organic Campaign Analysis") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Campaign level analysis of organic brand health
                            across owned media channels
                          </h3>
                        );
                      }

                      if (Label === "Paid Media Analysis") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Analysis of marketing spend and its impact across
                            the consumer disposition funnel – from awareness to
                            conversion
                          </h3>
                        );
                      }
                      if (Label === "Marketing Spend Analytics") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Deep dive into marketing spend from a time-series
                            and campaign mechanics perspective
                          </h3>
                        );
                      }
                      if (Label === "Organic Media Analytics") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Analysis of organic brand health in terms of
                            audience engagement, talkability and sentiment
                          </h3>
                        );
                      }
                      if (Label === "Sales And Product Analytics") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Deep dive into Sales & Revenue from a commercial
                            perspective
                          </h3>
                        );
                      }
                      if (Label === "Customer Analytics") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Web and Product Analytics giving a view of customer
                            behaviour
                          </h3>
                        );
                      }
                      if (
                        Label === "Inventory Visibility - Inventory visibility"
                      ) {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Quantitative analysis of inventory on-hand by date,
                            location, category and status
                          </h3>
                        );
                      }
                      if (
                        Label ===
                        "Product Sales Analytics - Product Sales Analytics"
                      ) {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Comprehensive overview of sales across categories
                            with sales force management perspective
                          </h3>
                        );
                      }
                      if (Label === "Stock Management - Stock Management") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Supply and demand inquiry of stock based on order
                            status and units fit for sale
                          </h3>
                        );
                      }
                      if (
                        Label ===
                        "Costs and Sales Analysis - Cost Vs Sales Analytics"
                      ) {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Deep dive into inventory costs and sales
                            contributing to total profits with an inquiry of
                            payables and receivables
                          </h3>
                        );
                      }
                      if (Label === "Supply Chain - Product Sales Analytics") {
                        return (
                          <h3 className="dashboard-tab-placeholder-title">
                            Investigation of inventory supply chain by tracking
                            supply and demand side for each product
                          </h3>
                        );
                      }
                    })()}
                  </div>
                  <Box>
                    <iframe
                      className="dashboard-iframe dashboard-iframe-medium"
                      frameBorder="0"
                      allowFullScreen={true}
                      src={dashboardUrl}
                      title="PI"
                    />
                  </Box>
                  {/* </Box> */}
                </TabPanel>
              );
            } else {
              return (
                <TabPanel key={i} index={i} value={value} {...a11yProps(i)}>
                  <Typography>Dashboard comming soon!</Typography>
                </TabPanel>
              );
            }
          })}
      </Box>
    </Box>
  );

  return (
    <AppContainer title={""} user={props.user}>
      <div>{Nav}</div>
    </AppContainer>
  );
}
